import React, { FC, memo } from 'react';
import { useAppTranslation } from 'app/config/i18Config/hooks';
import { LockState } from '../model/types';

interface LockStatusMarkerProps {
  lockStatus: LockState | undefined;
  isExternalBox?: boolean;
}

export const LockStatusMarker: FC<LockStatusMarkerProps> = memo((props) => {
  const { lockStatus, isExternalBox } = props;

  const { t } = useAppTranslation('contracts');

  if (isExternalBox) {
    return null;
  }

  return (
    <div
      className={`flex gap-1 items-center text-xs desktop:text-sm rounded-xl px-3.5 py-0.5 ${
        lockStatus === LockState.OPENED
          ? 'text-success bg-successLight'
          : lockStatus === LockState.CLOSED
          ? 'text-error bg-errorLight'
          : 'text-primary bg-secondary'
      }`}
    >
      {/* <div
        className={`w-2 h-2 rounded-full ${
          lockStatus === LockState.OPENED ? 'bg-success' : lockStatus === LockState.CLOSED ? 'bg-error' : 'bg-primaryLight'
        }`}
      /> */}
      {lockStatus === LockState.OPENED ? t('Opened') : lockStatus === LockState.CLOSED ? t('Closed') : t('N/A')}
    </div>
  );
});
